import { useAuthContext } from '../Providers/AuthContext';
import React, { PropsWithChildren, useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getAccessToken } from '../Services';

import { ROLE } from './../Utils/Role';

interface PrivateRouteInterface {
  component: React.ComponentType<any> | React.LazyExoticComponent<React.ComponentType<any>>;
  roles: Array<ROLE>;
  [key: string]: any;
}

/**
 * PrivateRoute
 * @param param PropsWithChildren<PrivateRouteInterface>
 * @returns
 */
const PrivateRoute = ({ component: Component, roles, ...rest }: PropsWithChildren<PrivateRouteInterface>) => {
  const { setOpenLogin } = useAuthContext();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const token = getAccessToken();
  const [isConnected, setisConnected] = useState(false);

  useEffect(() => {
    if (token !== null) {
      setisConnected(true);
    }
    // // Check user authentication ...
    // const authenticatedUserRole = ROLE.USER;
    // setIsAuthenticated(true);
    // // Check user roles ...
    // const userHasRequiredRole = roles.includes(authenticatedUserRole);
    // setIsGranted(userHasRequiredRole);
    // //
    setIsLoading(false);
    // // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const redirectTo = () => {
    if (!isLoading) {
      setOpenLogin(true);
      return <Redirect to="/" />;
    }
    return 'Loading ...';
  };

  return <Route {...rest} render={(props) => (isConnected ? <Component {...props} /> : redirectTo())} />;
};

export default PrivateRoute;
